package org.moxultimate.topwithmox.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.navigation.UncoloredLinkVariant
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vh
import org.moxultimate.topwithmox.components.layouts.PageLayoutData
import org.moxultimate.topwithmox.components.texts.moxTextGradient
import org.moxultimate.topwithmox.navigation.NavRoute
import org.moxultimate.topwithmox.theme.DarkTextColor
import org.moxultimate.topwithmox.theme.FontFamily

/**
 * NotFound — 404 error page
 * Displayed when a user navigates to a route that does not exist.
 * Exported as 404.html by Kobweb's static site generator.
 */

@InitRoute
fun initNotFoundRoute(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData("Page Not Found"))
}

@Page(routeOverride = "404")
@Layout(".components.layouts.PageLayout")
@Composable
fun NotFoundRoute() {
    NotFoundContent()
}

@Composable
private fun NotFoundContent() {
    Box(
        modifier = Modifier.fillMaxWidth().minHeight(80.vh),
        contentAlignment = Alignment.Center,
    ) {
        Column(
            modifier = Modifier.padding(leftRight = 24.px),
            horizontalAlignment = Alignment.CenterHorizontally,
        ) {
            SpanText(
                text = "404",
                modifier = Modifier
                    .fontFamily(FontFamily)
                    .fontSize(120.px)
                    .fontWeight(FontWeight.Bold)
                    .moxTextGradient(),
            )
            SpanText(
                text = "Page not found",
                modifier = Modifier
                    .fontFamily(FontFamily)
                    .fontSize(24.px)
                    .fontWeight(FontWeight.SemiBold)
                    .color(DarkTextColor)
                    .margin(top = 8.px),
            )
            SpanText(
                text = "The page you're looking for doesn't exist or has been moved.",
                modifier = Modifier
                    .fontFamily(FontFamily)
                    .fontSize(16.px)
                    .color(DarkTextColor)
                    .textAlign(TextAlign.Center)
                    .margin(top = 12.px, bottom = 32.px),
            )
            Link(
                path = NavRoute.DASHBOARD,
                variant = UncoloredLinkVariant,
            ) {
                SpanText(
                    text = "← Back to Home",
                    modifier = Modifier
                        .fontFamily(FontFamily)
                        .fontSize(16.px)
                        .fontWeight(FontWeight.SemiBold)
                        .moxTextGradient(),
                )
            }
        }
    }
}
